(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ao-account-choice"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('ao-account-choice')) {
  class AOAccountChoice extends HTMLElement {
    connectedCallback() {
      const dialog = this.querySelector('dialog');
      const close = this.querySelector('[data-ao-account-choice-close]');
      const title = this.querySelector('#AOAccountChoiceTitle');
      if (!dialog || !close || !title || typeof dialog.showModal !== 'function') return;
      this.abort?.abort();
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      const enhanceTriggers = () => {
        document.querySelectorAll('[data-ao-account-choice-open]').forEach((trigger) => {
          trigger.setAttribute('aria-haspopup', 'dialog');
          trigger.setAttribute('aria-controls', dialog.id);
        });
      };
      enhanceTriggers();
      document.addEventListener('shopify:section:load', enhanceTriggers, options);
      document.addEventListener('click', (event) => {
        if (!(event.target instanceof Element) || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        const trigger = event.target.closest('[data-ao-account-choice-open]');
        if (!trigger || dialog.open) return;
        try { dialog.showModal(); }
        catch (_) { return; }
        event.preventDefault();
        this.trigger = trigger;
        title.focus({ preventScroll: true });
      }, options);
      close.addEventListener('click', () => dialog.close(), options);
      dialog.addEventListener('click', (event) => {
        if (event.target !== dialog) return;
        const rect = dialog.getBoundingClientRect();
        if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
      }, options);
      dialog.addEventListener('close', () => {
        if (this.trigger?.isConnected) this.trigger.focus({ preventScroll: true });
      }, options);
    }
    disconnectedCallback() { this.abort?.abort(); }
  }
  customElements.define('ao-account-choice', AOAccountChoice);
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ao-audio-preview"] && !Shopify.designMode) return;
  try {
    document.addEventListener('play', (event) => {
    if (!(event.target instanceof HTMLAudioElement)) return;
    document.querySelectorAll('audio').forEach((audio) => {
      if (audio !== event.target) audio.pause();
    });
  }, true);
  document.addEventListener('error', (event) => {
    if (!(event.target instanceof HTMLAudioElement) || !event.target.matches('[data-ao-audio]')) return;
    const error = event.target.closest('[data-ao-audio-track]')?.querySelector('[data-ao-audio-error]');
    if (error) error.hidden = false;
  }, true);
  document.addEventListener('loadeddata', (event) => {
    if (!(event.target instanceof HTMLAudioElement) || !event.target.matches('[data-ao-audio]')) return;
    const error = event.target.closest('[data-ao-audio-track]')?.querySelector('[data-ao-audio-error]');
    if (error) error.hidden = true;
  }, true);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ao-discount-codes"] && !Shopify.designMode) return;
  try {
    (function(){
  if (window.__ao_discount_code_copy_init) return;
  window.__ao_discount_code_copy_init = true;
  document.addEventListener('click', async function(event){
    var button = event.target.closest('[data-ao-copy-code]');
    if (!button) return;
    var code = button.getAttribute('data-ao-copy-code');
    if (!code) return;
    var copied = false;
    try { if (navigator.clipboard && window.isSecureContext) {await navigator.clipboard.writeText(code); copied = true;} } catch(e){}
    if (!copied) {
      var temp = document.createElement('textarea');
      temp.value = code; temp.style.position = 'fixed'; temp.style.opacity = '0';
      document.body.appendChild(temp); temp.focus(); temp.select();
      try { copied = document.execCommand('copy'); } catch(e){}
      temp.remove();
      button.focus({preventScroll:true});
    }
    if (copied) {button.textContent=button.dataset.copySuccess; button.setAttribute('aria-label',button.dataset.copySuccessLabel);}
    else {button.textContent=button.dataset.copyFailure;button.setAttribute('aria-label',button.dataset.copyFailureLabel);}
  });
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ao-home-new-release-feed"] && !Shopify.designMode) return;
  try {
    (function(){
  function initializeAONewReleases(){
    document.querySelectorAll('[data-ao-new-release-scroll]').forEach(function(viewport){
      if(viewport.dataset.aoInitialized==='true')return;
      const track=viewport.querySelector('[data-ao-new-release-track]');
      const set=viewport.querySelector('[data-ao-new-release-set]');
      if(!track||!set)return;
      viewport.dataset.aoInitialized='true';
      const sorted=[...set.children].filter(n=>n.dataset.aoReleaseDate);
      const seen=new Set();
      sorted.sort((a,b)=>Number(b.dataset.aoReleaseDate)-Number(a.dataset.aoReleaseDate));
      sorted.forEach(function(card){
        const key=card.dataset.aoReleaseTitle||'';
        if(key&&seen.has(key)){card.remove();return;}
        seen.add(key);
        set.appendChild(card);
      });
      const motion=window.matchMedia('(prefers-reduced-motion: reduce)');
      if(set.children.length<2||motion.matches){
        viewport.style.overflowX='auto';
        track.style.animation='none';
        track.style.transform='none';
        return;
      }
      let offset=0,last=0,paused=false,inView=true;
      const pauseControl=viewport.closest('.ao-ns-releases').querySelector('[data-ao-news-pause]');
      const stop=()=>{paused=true;};
      const resume=()=>{paused=false;};
      viewport.addEventListener('pointerenter',stop);
      viewport.addEventListener('pointerleave',resume);
      viewport.addEventListener('focusin',stop);
      viewport.addEventListener('focusout',function(e){if(!viewport.contains(e.relatedTarget))resume();});
      if('IntersectionObserver' in window){
        new IntersectionObserver(function(entries){
          inView=entries.some(e=>e.isIntersecting);
        }).observe(viewport);
      }
      function animate(now){
        if(!viewport.isConnected)return;
        if(!last)last=now;
        const delta=Math.min(60,Math.max(0,now-last));last=now;
        if(!paused&&!pauseControl?.checked&&!motion.matches&&inView&&!document.hidden){
          offset+=delta*.022;
          let guard=0;
          while(set.children.length>1&&guard++<10){
            const first=set.firstElementChild;
            const gap=parseFloat(getComputedStyle(set).columnGap)||0;
            const width=first.getBoundingClientRect().width+gap;
            if(!width||offset<width)break;
            offset-=width;
            set.appendChild(first);
          }
          track.style.transform='translate3d('+(-offset)+'px,0,0)';
        }
        requestAnimationFrame(animate);
      }
      requestAnimationFrame(animate);
    });
  }
  if(document.readyState==='loading'){
    document.addEventListener('DOMContentLoaded',initializeAONewReleases,{once:true});
  }else{
    initializeAONewReleases();
  }
  document.addEventListener('shopify:section:load',initializeAONewReleases);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ao-image-zoom"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('ao-image-zoom')) {
  customElements.define('ao-image-zoom', class extends HTMLElement {
    connectedCallback() {
      if (this._controller) return;
      this._controller = new AbortController();
      const options = { signal: this._controller.signal };
      this.dialog = this.querySelector('dialog');
      this.stage = this.querySelector('[data-zoom-stage]');
      this.canvas = this.querySelector('[data-zoom-canvas]');
      this.image = this.querySelector('[data-zoom-image]');
      this.imageButton = this.querySelector('[data-zoom-image-button]');
      this.toggleButton = this.querySelector('[data-zoom-toggle]');
      this.status = this.querySelector('[data-zoom-status]');
      this.hint = this.querySelector('[data-zoom-hint]');
      this.previous = this.querySelector('[data-zoom-previous]');
      this.next = this.querySelector('[data-zoom-next]');
      document.addEventListener('click', (event) => {
        const trigger = event.target.closest('a[data-ao-zoom]');
        if (!trigger || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || !this.dialog.showModal) return;
        event.preventDefault();
        const group = trigger.dataset.aoZoomGroup;
        const candidates = group ? Array.from(document.querySelectorAll('a[data-ao-zoom]')).filter((item) => item.dataset.aoZoomGroup === group) : [trigger];
        const seen = new Set();
        this._items = candidates.filter((item) => { if (seen.has(item.href)) return false; seen.add(item.href); return true; });
        this._trigger = trigger;
        if (!this.dialog.open) this.dialog.showModal();
        document.documentElement.classList.add('ao-image-zoom-open');
        this._select(Math.max(0, this._items.findIndex((item) => item.href === trigger.href)));
      }, options);
      this.querySelector('[data-zoom-close]').addEventListener('click', () => this.dialog.close(), options);
      this.dialog.addEventListener('close', () => {
        document.documentElement.classList.remove('ao-image-zoom-open');
        this.stage.classList.remove('is-dragging');
        this._drag = null;
        if (this._trigger?.isConnected) this._trigger.focus({ preventScroll: true });
      }, options);
      this.dialog.addEventListener('click', (event) => {
        if (event.target !== this.dialog) return;
        const box = this.dialog.getBoundingClientRect();
        if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) this.dialog.close();
      }, options);
      this.previous.addEventListener('click', () => this._select(this._index - 1), options);
      this.next.addEventListener('click', () => this._select(this._index + 1), options);
      this.toggleButton.addEventListener('click', () => this._toggle(), options);
      this.imageButton.addEventListener('click', () => this._toggle(), options);
      this.dialog.addEventListener('keydown', (event) => {
        if (!['ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown'].includes(event.key)) return;
        if (this._zoomed) {
          event.preventDefault();
          this.stage.scrollBy({ left: event.key === 'ArrowLeft' ? -90 : event.key === 'ArrowRight' ? 90 : 0, top: event.key === 'ArrowUp' ? -90 : event.key === 'ArrowDown' ? 90 : 0 });
        } else if (this._items.length > 1 && ['ArrowLeft', 'ArrowRight'].includes(event.key)) {
          event.preventDefault();
          this._select(this._index + (event.key === 'ArrowRight' ? 1 : -1));
        }
      }, options);
      this.image.addEventListener('load', () => {
        this.image.hidden = false;
        this.toggleButton.disabled = false;
        this.imageButton.disabled = false;
        this.status.textContent = this._fallbackAttempted ? this.dataset.error : '';
        this._render(true);
      }, options);
      this.image.addEventListener('error', () => {
        if (!this._fallbackAttempted && this._fallback && this._fallback !== this.image.src) {
          this._fallbackAttempted = true;
          this.image.src = this._fallback;
          return;
        }
        this.status.textContent = this.dataset.error;
        this.image.hidden = true;
      }, options);
      this.stage.addEventListener('pointerdown', (event) => {
        if (!this._zoomed || event.pointerType !== 'mouse' || event.button !== 0) return;
        this._dragMoved = false;
        this._drag = { x: event.clientX, y: event.clientY, left: this.stage.scrollLeft, top: this.stage.scrollTop };
      }, options);
      this.stage.addEventListener('pointermove', (event) => {
        if (!this._drag) return;
        const x = event.clientX - this._drag.x;
        const y = event.clientY - this._drag.y;
        if (Math.abs(x) + Math.abs(y) < 5 && !this._dragMoved) return;
        if (!this._dragMoved) this.stage.setPointerCapture(event.pointerId);
        this._dragMoved = true;
        this.stage.classList.add('is-dragging');
        this.stage.scrollLeft = this._drag.left - x;
        this.stage.scrollTop = this._drag.top - y;
      }, options);
      const release = () => { this._drag = null; this.stage.classList.remove('is-dragging'); };
      this.stage.addEventListener('pointerup', release, options);
      this.stage.addEventListener('pointercancel', release, options);
      this.stage.addEventListener('click', (event) => {
        if (!this._dragMoved) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        this._dragMoved = false;
      }, { ...options, capture: true });
      this._resize = new ResizeObserver(() => { if (this.dialog.open) this._render(false); });
      this._resize.observe(this.stage);
    }
    _select(index) {
      this._index = (index + this._items.length) % this._items.length;
      const trigger = this._items[this._index];
      const source = trigger.querySelector('img');
      this._width = Number(trigger.dataset.zoomWidth) || source?.naturalWidth || 1600;
      this._height = Number(trigger.dataset.zoomHeight) || source?.naturalHeight || 1600;
      this._fallback = trigger.dataset.zoomPreview || source?.currentSrc || '';
      this._fallbackAttempted = false;
      this._zoomed = false;
      this._dragMoved = false;
      this.image.hidden = true;
      this.image.alt = trigger.dataset.zoomAlt || source?.alt || '';
      this.querySelector('[data-zoom-title]').textContent = trigger.dataset.zoomTitle || this.image.alt;
      this.querySelector('[data-zoom-count]').textContent = `${this._index + 1} / ${this._items.length}`;
      this.querySelector('[data-zoom-original]').href = trigger.href;
      this.previous.hidden = this.next.hidden = this._items.length < 2;
      this.toggleButton.disabled = true;
      this.imageButton.disabled = true;
      this.status.textContent = this.dataset.loading;
      this.image.src = trigger.href;
      this._render(true);
    }
    _toggle() {
      if (this.toggleButton.disabled) return;
      this._zoomed = !this._zoomed;
      this._render(true);
    }
    _render(center) {
      const width = this.stage.clientWidth;
      const height = this.stage.clientHeight;
      if (!width || !height) return;
      const x = center ? .5 : (this.stage.scrollLeft + width / 2) / (this.canvas.offsetWidth || width);
      const y = center ? .5 : (this.stage.scrollTop + height / 2) / (this.canvas.offsetHeight || height);
      const naturalWidth = !this.image.hidden && this.image.naturalWidth ? this.image.naturalWidth : this._width || 1600;
      const naturalHeight = !this.image.hidden && this.image.naturalHeight ? this.image.naturalHeight : this._height || 1600;
      const ratio = naturalWidth / naturalHeight;
      const fit = Math.max(1, Math.min(width - 32, (height - 32) * ratio, naturalWidth));
      const imageWidth = Math.round(fit * (this._zoomed ? 2 : 1));
      const imageHeight = Math.round(imageWidth / ratio);
      const canvasWidth = Math.max(width, imageWidth + 32);
      const canvasHeight = Math.max(height, imageHeight + 32);
      this.image.style.width = `${imageWidth}px`;
      this.image.style.height = `${imageHeight}px`;
      this.canvas.style.width = `${canvasWidth}px`;
      this.canvas.style.height = `${canvasHeight}px`;
      this.stage.classList.toggle('is-zoomed', this._zoomed);
      this.toggleButton.textContent = this._zoomed ? this.dataset.shrink : this.dataset.enlarge;
      this.toggleButton.setAttribute('aria-pressed', String(this._zoomed));
      this.imageButton.setAttribute('aria-pressed', String(this._zoomed));
      this.imageButton.setAttribute('aria-label', this._zoomed ? this.dataset.shrink : this.dataset.enlarge);
      this.hint.textContent = this._zoomed ? this.dataset.hintZoom : this.dataset.hint;
      this.stage.scrollLeft = x * canvasWidth - width / 2;
      this.stage.scrollTop = y * canvasHeight - height / 2;
    }
    disconnectedCallback() {
      this._controller?.abort();
      this._controller = null;
      this._resize?.disconnect();
      if (this.dialog?.open) this.dialog.close();
      document.documentElement.classList.remove('ao-image-zoom-open');
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ao-legal-guarantee"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('ao-legal-guarantee')) {
  class AOLegalGuarantee extends HTMLElement {
    connectedCallback() {
      this.abort?.abort();
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      const dialog = this.querySelector('dialog');
      const close = this.querySelector('[data-ao-guarantee-close]');
      const image = this.querySelector('[data-ao-guarantee-image]');
      const error = this.querySelector('[data-ao-guarantee-error]');
      if (!dialog || !close || !image || typeof dialog.showModal !== 'function') return;
      document.querySelectorAll('[data-ao-guarantee-open]').forEach((trigger) => {
        trigger.setAttribute('aria-haspopup', 'dialog');
        trigger.setAttribute('aria-controls', dialog.id);
      });
      document.addEventListener('click', (event) => {
        const trigger = event.target instanceof Element ? event.target.closest('[data-ao-guarantee-open]') : null;
        if (!trigger || event.defaultPrevented || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.button > 0) return;
        if (dialog.open) { event.preventDefault(); return; }
        try { dialog.showModal(); } catch (_) { return; }
        event.preventDefault();
        this.opener = trigger;
        if (!image.hasAttribute('src')) image.src = image.dataset.src;
        close.focus({ preventScroll: true });
      }, options);
      image.addEventListener('error', () => { error.hidden = false; }, options);
      image.addEventListener('load', () => { error.hidden = true; }, options);
      close.addEventListener('click', () => dialog.close(), options);
      dialog.addEventListener('close', () => {
        if (this.opener?.isConnected) this.opener.focus({ preventScroll: true });
      }, options);
    }
    disconnectedCallback() { this.abort?.abort(); }
  }
  customElements.define('ao-legal-guarantee', AOLegalGuarantee);
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ao-planet-page"] && !Shopify.designMode) return;
  try {
    (() => {
  const observers = new WeakMap();
  const setup = () => {
    document.querySelectorAll('[data-ao-home-layout]').forEach((home) => {
      if (observers.has(home)) return;
      const welcome = home.querySelector('[data-ao-home-welcome]');
      if (!welcome) return;
      const update = () => home.style.setProperty('--ao-home-intro-height', Math.ceil(welcome.getBoundingClientRect().height) + 'px');
      update();
      if ('ResizeObserver' in window) {
        const observer = new ResizeObserver(update);
        observer.observe(welcome);
        observers.set(home, observer);
      }
    });
  };
  document.addEventListener('shopify:section:unload', (event) => {
    event.target.querySelectorAll('[data-ao-home-layout]').forEach((home) => {
      observers.get(home)?.disconnect();
      observers.delete(home);
    });
  });
  document.addEventListener('shopify:section:load', setup);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', setup, { once: true });
  else setup();
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ao-privacy"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('ao-privacy-dialog')) {
    class AOPrivacyDialog extends HTMLElement {
      static pendingAPI = null;

      static api() {
        const ready = () => {
          const api = window.Shopify?.customerPrivacy;
          return typeof api?.currentVisitorConsent === 'function' && typeof api?.setTrackingConsent === 'function' ? api : null;
        };
        if (ready()) return Promise.resolve(ready());
        if (AOPrivacyDialog.pendingAPI) return AOPrivacyDialog.pendingAPI;
        AOPrivacyDialog.pendingAPI = new Promise((resolve, reject) => {
          let settled = false;
          const complete = (error) => {
            if (settled) return;
            settled = true;
            clearTimeout(timeout);
            const api = ready();
            if (error || !api) reject(new Error('load'));
            else resolve(api);
          };
          const timeout = setTimeout(() => complete(new Error('timeout')), 10000);
          try {
            if (typeof window.Shopify?.loadFeatures !== 'function') throw new Error('unavailable');
            window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.2' }], complete);
          } catch (error) { complete(error); }
        }).catch((error) => { AOPrivacyDialog.pendingAPI = null; throw error; });
        return AOPrivacyDialog.pendingAPI;
      }

      connectedCallback() {
        this.dialog = this.querySelector('dialog');
        if (typeof this.dialog?.showModal !== 'function') {
          const policy = this.dialog?.querySelector('a')?.href;
          document.querySelectorAll('[data-ao-privacy-open]').forEach((trigger) => {
            trigger.addEventListener('click', () => { if (policy) window.location.assign(policy); }, { once: true });
          });
          return;
        }
        this.abort?.abort();
        this.abort = new AbortController();
        this.sequence = 0;
        this.fields = this.querySelector('[data-ao-consent-options]');
        this.inputs = [...this.querySelectorAll('[data-ao-consent-choice]')];
        this.status = this.querySelector('[data-ao-consent-status]');
        this.error = this.querySelector('[data-ao-consent-error]');
        this.retry = this.querySelector('[data-ao-consent-retry]');
        this.closeButton = this.querySelector('[data-ao-consent-close]');
        this.saveButton = this.querySelector('[data-ao-consent-save]');
        this.necessaryButton = this.querySelector('[data-ao-consent-necessary]');
        const options = { signal: this.abort.signal };
        document.addEventListener('click', (event) => {
          const trigger = event.target.closest('[data-ao-privacy-open]');
          if (!trigger) return;
          event.preventDefault();
          this.open(trigger);
        }, options);
        this.closeButton.addEventListener('click', () => this.dialog.close(), options);
        this.dialog.addEventListener('close', () => {
          this.sequence += 1;
          if (this.opener?.isConnected) this.opener.focus();
        }, options);
        this.retry.addEventListener('click', () => this.load(), options);
        this.saveButton.addEventListener('click', () => this.save(false), options);
        this.necessaryButton.addEventListener('click', () => this.save(true), options);
        this.fields.addEventListener('change', () => { this.status.textContent = ''; this.error.hidden = true; }, options);
        document.querySelectorAll('[data-ao-privacy-open]').forEach((trigger) => {
          trigger.setAttribute('aria-haspopup', 'dialog');
          trigger.setAttribute('aria-controls', this.dialog.id);
        });
        this.initialiseBanner();
      }

      async initialiseBanner() {
        try {
          const api = await AOPrivacyDialog.api();
          if (!this.isConnected || this.dialog.open) return;
          const nativeBanner = document.querySelector('script[src*="/privacy-banner/privacy-banner.js"]');
          if (nativeBanner) return;
          const consent = api.currentVisitorConsent();
          const undecided = ['analytics', 'marketing', 'preferences'].every((key) => consent?.[key] !== 'yes' && consent?.[key] !== 'no');
          if (undecided && typeof api.shouldShowBanner === 'function' && api.shouldShowBanner()) this.open(null);
        } catch (error) {
          this.privacyAPI = null;
        }
      }

      disconnectedCallback() { this.abort?.abort(); this.sequence += 1; }

      controls(disabled, busy = disabled) {
        this.fields.disabled = disabled;
        this.saveButton.disabled = disabled;
        this.necessaryButton.disabled = disabled;
        this.fields.setAttribute('aria-busy', String(busy));
      }

      failure(key, retry) {
        this.status.textContent = '';
        this.error.textContent = navigator.onLine === false ? this.dataset.offline : this.dataset[key];
        this.error.hidden = false;
        this.retry.hidden = !retry;
      }

      open(trigger) {
        if (this.dialog.open) return;
        this.opener = trigger;
        this.dialog.showModal();
        this.closeButton.focus();
        this.load();
      }

      async load() {
        const sequence = ++this.sequence;
        this.controls(true);
        this.error.hidden = true;
        this.retry.hidden = true;
        this.inputs.forEach((input) => { input.checked = false; });
        this.status.textContent = this.dataset.loading;
        try {
          if (navigator.onLine === false) throw new Error('offline');
          const api = await AOPrivacyDialog.api();
          if (sequence !== this.sequence || !this.dialog.open) return;
          const consent = api.currentVisitorConsent();
          if (!consent || typeof consent !== 'object') throw new Error('unavailable');
          this.privacyAPI = api;
          this.inputs.forEach((input) => { input.checked = consent[input.dataset.aoConsentChoice] === 'yes'; });
          this.status.textContent = '';
          this.controls(false);
        } catch (error) {
          if (sequence !== this.sequence || !this.dialog.open) return;
          this.controls(true, false);
          this.failure('loadError', true);
        }
      }

      async save(necessary) {
        if (!this.privacyAPI || this.saveButton.disabled) return;
        const selection = Object.fromEntries(this.inputs.map((input) => [input.dataset.aoConsentChoice, necessary ? false : input.checked]));
        if (necessary) selection.sale_of_data = false;
        const sequence = ++this.sequence;
        this.controls(true);
        this.error.hidden = true;
        this.retry.hidden = true;
        this.status.textContent = this.dataset.saving;
        try {
          if (navigator.onLine === false) throw new Error('offline');
          await new Promise((resolve, reject) => {
            let settled = false;
            const complete = (result) => {
              if (settled) return;
              settled = true;
              clearTimeout(timeout);
              if (result instanceof Error || typeof result === 'string' || result?.error || result?.errors) reject(new Error('save'));
              else resolve();
            };
            const timeout = setTimeout(() => complete(new Error('timeout')), 10000);
            try { this.privacyAPI.setTrackingConsent(selection, complete); }
            catch (error) { complete(error); }
          });
          const recorded = this.privacyAPI.currentVisitorConsent();
          if (!Object.entries(selection).every(([key, value]) => recorded?.[key] === (value ? 'yes' : 'no'))) throw new Error('unconfirmed');
          if (sequence !== this.sequence || !this.dialog.open) return;
          this.inputs.forEach((input) => { input.checked = recorded[input.dataset.aoConsentChoice] === 'yes'; });
          this.status.textContent = this.dataset.saved;
        } catch (error) {
          if (sequence !== this.sequence || !this.dialog.open) return;
          this.failure('saveError', false);
        } finally {
          if (sequence === this.sequence && this.dialog.open) this.controls(false);
        }
      }
    }
    customElements.define('ao-privacy-dialog', AOPrivacyDialog);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ao-shop-active-discounts"] && !Shopify.designMode) return;
  try {
    (function(){
 if(window.__aoActiveDiscountCopyInstalled)return;
 window.__aoActiveDiscountCopyInstalled=true;
 document.addEventListener('click',async function(ev){
  const btn=ev.target.closest('[data-ao-active-copy]');
  if(!btn)return;
  const code=btn.getAttribute('data-ao-active-copy')||'';
  if(!code)return;
  let success=false;
  try{if(navigator.clipboard&&window.isSecureContext){await navigator.clipboard.writeText(code);success=true;}}catch(e){}
  if(!success){const inp=document.createElement('textarea');inp.value=code;inp.style.position='fixed';inp.style.left='-9999px';document.body.appendChild(inp);inp.select();try{success=document.execCommand('copy');}catch(e){}inp.remove();}
  const status=btn.closest('.ao-active-deals')?.querySelector('.ao-active-deals__copy-status');
  if(status)status.textContent=success?('Code '+code+' kopiert ✓'):'Bitte Code '+code+' manuell kopieren';
 });
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ao-shop-planet-catalog"] && !Shopify.designMode) return;
  try {
    (() => {
  const sync = (panel) => {
    document.querySelectorAll('[data-ao-planet-toggle]').forEach((control) => {
      if (control.dataset.aoPlanetToggle === panel.id) control.setAttribute('aria-expanded', String(panel.open));
    });
    panel.querySelectorAll('.ao-shop-catalog__toggle-state').forEach((state) => {
      state.textContent = panel.open ? state.dataset.closeLabel : state.dataset.openLabel;
    });
  };
  const openHashPanel = () => {
    let id;
    try { id = decodeURIComponent(window.location.hash.slice(1)); }
    catch (_) { return; }
    if (!id) return;
    const panel = document.getElementById(id);
    if (!(panel instanceof HTMLDetailsElement) || !panel.matches('[data-ao-planet-panel]')) return;
    panel.open = true;
    sync(panel);
    window.requestAnimationFrame(() => panel.scrollIntoView({ block: 'start', behavior: 'auto' }));
  };
  const setup = () => {
    document.querySelectorAll('details[data-ao-planet-panel]').forEach(sync);
    openHashPanel();
  };
  document.addEventListener('click', (event) => {
    if (!(event.target instanceof Element)) return;
    const control = event.target.closest('[data-ao-planet-toggle]');
    if (!control) return;
    const panel = document.getElementById(control.dataset.aoPlanetToggle);
    if (!(panel instanceof HTMLDetailsElement)) return;
    event.preventDefault();
    panel.open = !panel.open;
    sync(panel);
    if (panel.open) panel.scrollIntoView({ block: 'start', behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
  });
  document.addEventListener('toggle', (event) => {
    if (event.target instanceof HTMLDetailsElement && event.target.matches('[data-ao-planet-panel]')) sync(event.target);
  }, true);
  window.addEventListener('hashchange', openHashPanel);
  document.addEventListener('shopify:section:load', setup);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', setup, { once: true });
  else setup();
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ao-spotify-player"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', function(event) {
  if (!(event.target instanceof Element)) return;
  const button = event.target.closest('[data-ao-spotify-toggle]');
  if (!button) return;
  const player = button.closest('[data-ao-spotify-player]');
  const frame = player?.querySelector('[data-ao-spotify-frame]');
  const template = player?.querySelector('[data-ao-spotify-template]');
  if (!frame || !(template instanceof HTMLTemplateElement)) return;
  if (button.getAttribute('aria-expanded') === 'true') {
    frame.replaceChildren();
    frame.hidden = true;
    button.setAttribute('aria-expanded', 'false');
    button.textContent = button.dataset.loadLabel;
    return;
  }
  const iframe = template.content.querySelector('iframe')?.cloneNode(true);
  if (!(iframe instanceof HTMLIFrameElement)) return;
  const source = iframe.dataset.src;
  if (!/^https:\/\/open\.spotify\.com\/embed\/(album|track)\/[a-zA-Z0-9]{22}$/.test(source || '')) return;
  iframe.src = source;
  iframe.removeAttribute('data-src');
  frame.replaceChildren(iframe);
  frame.hidden = false;
  button.setAttribute('aria-expanded', 'true');
  button.textContent = button.dataset.removeLabel;
});
  } catch(e) { console.error(e); }
})();

})();
